import React from "react";
import { Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";
import CustomInputField from "../../../../components/common/CustomInputField";
import { useSelector } from "react-redux";
import {
  GetRenewalAdjustmentByClientId,
  UpdateAdjustment,
} from "../../../../api/User/ACG/RenewalAdjustmentApi";

const schema = Yup.object().shape({
  renewal_Adj_Pct: Yup.number()
    .typeError("Please enter a valid number")
    .required("required"),
});

const RenewalAdjustment = () => {
  const client = useSelector((state) => state.clientData.value);
  const [data, setData] = useState([]);
  const [isGetData, setIsGetData] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const buttonRef = useRef(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const column = [
    { title: "Client ID", field: "client_ID" },
    { title: "Carrier", field: "carrier" },
    { title: "Plan Name", field: "plan_Name" },
    {
      title: "Renewal Increase",
      field: "renewal_Adj_Pct",
      render: (rowData) => (rowData.renewal_Adj_Pct * 100).toFixed(2) + "%",
    },
  ];

  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
    if (isGetData) {
      getData();
    }
    setIsGetData(false);
  }, [showModal]);

  useEffect(() => {
    getData();
  }, [client]);

  const getData = () => {
    setIsLoading(true);
    GetRenewalAdjustmentByClientId(client?.clientID)
      .then((res) => {
        if(res.status === 200 || res.status === 204){
        setData(res.data);
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  const handleActions = (values) => {
    const { renewal_Adj_Pct } = values;
    const payload = {
      ...selectedRowData,
      renewal_Adj_Pct: +renewal_Adj_Pct,
    };

    UpdateAdjustment(payload).then((res) => {
      if(res.status === 200 || res.status === 204){
      setIsGetData(true);
      toastFile("update");
      setShowModal(false);
      }
    });
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            Update Renewal Adjustment
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validationSchema={schema}
            onSubmit={handleActions}
            initialValues={{
              renewal_Adj_Pct: selectedRowData?.renewal_Adj_Pct ?? 0,
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              touched,
              errors,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Row className="mb-2">
                  <CustomInputField
                    label="Renewal Adjustment Pct"
                    name="renewal_Adj_Pct"
                    maxLength={10}
                    value={values}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    touched={touched}
                    errors={errors}
                    isRequired
                  />
                </Row>
                <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                  <button
                    Ref={buttonRef}
                    style={Fontstyling.savebutton}
                    type="submit"
                  >
                    Save
                  </button>
                  <button
                    style={Fontstyling.cancelbutton}
                    onClick={() => setShowModal(false)}
                    type="button"
                  >
                    Cancel
                  </button>
                </div>
                <span className="text-success" style={{fontSize:"12px"}}>
                  * No special characters are allowed
                </span>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
      <CustomMaterialTable
        isExport={false}
        isDelete={false}
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={() => {}}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
        isLoading={isLoading}
      />
    </div>
  );
};

export default RenewalAdjustment;
